/*global $, document, window, setTimeout, alert, typeof, FG*/
(function () {
    "use strict";

    FG.User = {

        /**
         * Session ID from server. hi jim :)
         * @param {String}
         */
        sessionId: null,

        /**
         * Is this user currently logged in
         * @param {Bool}
         */
        isLoggedIn: false,

        /**
         * User's first name
         * @param {String}
         */
        firstName: null,

        /**
         * User's person id
         * @param {Number}
         */
        personId: null,

        /**
         * Number of seconds till the user's session expires
         * i.e. If they visit the site after these many seconds, they should not see cart expired page.
         * @parsm {Number}
         */
        sessionExpireThresholdSeconds: 3600,

        /**
         * Initialize this object
         * @constructor
         */
        init: function () {
            this.ensureLoginStatusProperty();
            this.ensureNavigationBar();
            this.bindToSignInForm();
            this.bindSignoutLink();
            this.bindToPaymentPlanMangerPayInFull();
            this.bindToPaymentPlanManagerRetryPayment();
            this.ensureCleanSessionExpiry();
            this.bindErrorLink();

            function getUrlParameter(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            }

            // Attempt to show login modal
            // originally only receipt email as ref, added sms , this lets us track where the clicks come from, in theory
            $(function() {
                if (getUrlParameter('ref') === 'email' || getUrlParameter('ref') === 'sms') {
                    if ($('#topNav').hasClass('guest')) {
                        $('#link-global-signin').trigger('click');
                    }
                }
            });

            var $layawayContainer = $('#layawayContainer');
            if ($layawayContainer.length) {
                FGTLibs.userAccountAPICalls().then(function (results) {
                    var props = {
                        containerId: 'layawayContainer',
                        orderId: $layawayContainer.data('orderid'),
                        insuranceCost: $layawayContainer.data('insurancecost'),
                        auth: results[0].braintreeToken,
                        billing: results[0].contactAddress,
                        countryList: results[0].countryList,
                        availablePayments: results[0].availablePayments,
                        locale: (results[0].locale ? results[0].locale.split('.')[0] : 'en_US.utf8'),
                        useCaptcha: results[0].useCaptcha,
                        captchaSiteKey: results[0].captchaSiteKey,
                    };
                    if (results[0].use3DSecure && results[0].locale === 'en_GB.utf8') {
                        // Zero active layaway orders will return an empty array in data
                        // else an object is returned when there is an active layaway order
                        if ( !Array.isArray(results[1].data) ) {
                            props['planAgree'] = results[1].data;
                        }
                    }
                    window.FGTLibs.layawayApp(props);
                });
            }

            var $refundBannerContainer = $('#refundBannerContainer');
            if ($refundBannerContainer.length) {
              window.FGTLibs.renderRefundBanner({
                containerId: 'refundBannerContainer',
                orderId: $refundBannerContainer.data('orderid'),
              });
            }

            var $refundProcessedContainer = $('#refundProcessedContainer');
            if ($refundProcessedContainer.length) {
              window.FGTLibs.renderRefundProcessed({
                containerId: 'refundProcessedContainer',
                orderId: $refundProcessedContainer.data('orderid'),
              });
            }

            var $accountStorePayment = $('#account-store-payment');
            if ($accountStorePayment.length) {
                FGTLibs.userAccountAPICalls().then(function (results) {
                    var props = {
                        containerId: 'account-store-payment',
                        auth: $('#braintree_token').val(),
                        billing: results[0].contactAddress,
                        storedPayment: results[0].storedPayment,
                        countryList: results[0].countryList,
                        availablePayments: results[0].availablePayments,
                        isAccountLocked: results[0].isAccountLocked,
                        locale: (results[0].locale ? results[0].locale.split('.')[0] : 'en_US.utf8'),
                        useCaptcha: results[0].useCaptcha,
                        captchaSiteKey: results[0].captchaSiteKey,
                    };
                    if (results[0].use3DSecure && results[0].locale === 'en_GB.utf8') {
                        // Zero active layaway orders will return an empty array in data
                        // else an object is returned when there is an active layaway order
                        if ( !Array.isArray(results[1].data) ) {
                            props['planAgree'] = results[1].data;
                        }
                    }
                    window.FGTLibs.renderUserAccount(props);
                });
            }

            $('[data-toggle="tooltip"]').tooltip();

            $('.tm-modal-link').click(function(){
                $('#modal-resale').modal();
            });

            $('.open-fulfillment-modal').on('click keypress', function(evt) {
                if (evt.type === 'click' || evt.keyCode === 13) {
                    $('#modal-fulfillment').modal({keyboard: true});
                }
            });
        },

        bindToSignInForm : function() {
            $('#form-signin, #form-checkout-signin').submit(this.handleUserSignIn);
        },

        bindErrorLink: function() {
            $('div.billing-error').on('click', 'a.tabswitch', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $("#userSigninTabs a[href='"+ $(this).attr('href') +"']").click();
            });
        },

        /**
         * Handle click event when a user tries to sign in
         * @returns {boolean}
         */
        handleUserSignIn: function (e) {

            var currentForm = $(this),
                email = currentForm.find('#txt-login-email').val(),
                password = currentForm.find('#txt-login-pass').val(),
                Ajax = new FG.AjaxJob('user/signin'),
                $btnUserSingin = currentForm.find(".btn-user-signin"),
                laddaBtnSignIn = new FG.Ladda($btnUserSingin.get(0))

            e.preventDefault();

            FG.Base.initValidateForm(currentForm);
            if (!FG.Base.validateForm(currentForm)){
                return false;
            }

            try {
                currentForm.find('.div-signin-error').html('').addClass('hide');

                //Disable the signin button
                $btnUserSingin.attr('disabled', 'disabled');

                laddaBtnSignIn.start();

                Ajax.setLaddaButton(laddaBtnSignIn);

                Ajax.setMessageDiv(currentForm.find('.div-signin-error'));

                Ajax.setRequestData({
                    email: email,
                    password: password
                });

                Ajax.setSuccessCallback(function (FGResponse) {

                    //Set a login cookie

                    var expDate = new Date();
                    expDate.setTime(expDate.getTime() + (sessionTimeOut*1000));

                    $.cookie("FG_LOGGED_IN", 1, {path: '/', expires: expDate });

                    //Set a login type cookie
                    $.cookie("FG_LOGIN_TYPE", 'ExistingAccount', {path: '/'});

                    //Remove the custom cookie
                    $.removeCookie('FG_CUSTOM', {path: '/'});

                    var db = new FG.DB();
                    db.set('activeWaitlistRequest', FGResponse.data.activeWaitlistRequest);

                    // Remove resale parameter after signing in. related to not wanting the TMR instructions modal to appear.
                    var url = new URL(window.location);
                    if (url.searchParams.has('resale')) {
                        url.searchParams.delete('resale');
                        window.history.replaceState({}, '', url.href);
                    }

                    setTimeout(function () {
                        // if the user was logging in on the forgot password page, send them to label page
                        if (url.pathname.indexOf('user/forgot_password') !== -1) {
                            window.location.replace(url.href.replace('user/forgot_password', ''));
                        } else {
                            window.location.reload();
                        }
                    }, 200);

                });

                Ajax.setFailureCallback(function (FGResponse) {
                    laddaBtnSignIn.stop();
                    currentForm.find('.div-signin-error').html(FGResponse.msg).addClass('alert alert-warning').removeClass('hide');
                    $btnUserSingin.removeAttr('disabled').text(window.FGTLibs.i18n.t('Sign In'));
                    return false;
                });

                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },

        initSignupValidation: function () {
            var self = this;
            // if validator exists, remove event listeners and destroy before creating again
            if (self.signupValidator) {
                self.signupValidator.disarm();
                self.signupValidator = null;
            }

            var signupValidatorConfig = [
                { id: "create_firstName", type: ['required', 'noHTML'], },
                { id: "create_lastName", type: ['required', 'noHTML'], },
                { id: "create_email", type: ['required', 'noHTML', 'isEmail'], },
            ];

            var highlightInput = function(element, validation) {
                var msgId = $(element).attr('id').concat('-error');
                var errorEl = $('#div-create-error');

                if($(element).parents('form').find('div#' + msgId ).length > 0){
                        $(element).attr('aria-describedby', '');
                        $(element).parents('form').find('div#' + msgId ).remove();
                }

                $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
                $(element).parent()[validation.pass ? 'removeClass' : 'addClass']('invalid');

                if (!validation.pass && validation.message !== '') {
                    var msgAttr = validation.message.toLowerCase().replace(/\s/g, '_');
                    if($(element).parents('form').find('div#' + msgId).length == 0){
                        $(element).attr('aria-describedby', msgId);
                        $(element).parent()
                        .append('<div id="' + msgId + '" class="error-msg invalid" data-msg-text="' + msgAttr + '">' + validation.message + '</div>')
                        .show();
                    }
                    $('#btn-user-create').attr('disabled', true);
                }else{
                    $('#btn-user-create').removeAttr('disabled');
                }
            };

            self.signupValidator = new FGTLibs.InputValidator(signupValidatorConfig, highlightInput);
        },

        /**
         * Create a new user
         */
        createNewAccount: function(){

            var self = this,
                currentForm = $(self),
                firstName = $("#create_firstName").val(),
                lastName = $("#create_lastName").val(),
                email = $("#create_email").val(),
                password = $("#create_new_password").val(),
                confirmPassword = $("#create_confirm_password").val(),
                lower = new RegExp("[a-z]"),
                upper = new RegExp("[A-Z]"),
                numb = new RegExp("[0-9]"),
                Ajax = new FG.AjaxJob('user/create_account'),
                $btnSignUp = $('#btn-user-create'),
                ladaBtnSignUp = new FG.Ladda($btnSignUp.get(0)),
                formValid = true;

            self.initSignupValidation();

            if(self.signupValidator && !self.signupValidator.checkAll().pass) {
                formValid = false;
            }

            if (!lower.test(password) || !upper.test(password) || !numb.test(password) || password.length < 8) {
                $('#create_new_password').addClass('invalid');
                $('label[for="create_new_password"]').addClass('invalid');
                formValid =  false;
            }

            if (password !== confirmPassword) {
                $('#create_confirm_password').addClass('invalid');
                $('label[for="create_confirm_password"]').addClass('invalid');
                formValid = false;
            }

            if (formValid) {
                $btnSignUp.attr('disabled', 'disabled');

                ladaBtnSignUp.start();
                try {
                    Ajax.setLaddaButton(ladaBtnSignUp);

                    Ajax.setRequestData({
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        password: password,
                        confirmPassword: confirmPassword
                    });

                    Ajax.setSuccessCallback(function (FGResponse) {

                        $.cookie('FG_LOGIN_TYPE', 'CreateAccount', { path: '/'});
                        $('#div-create-success').removeClass('hide').fadeIn('slow', function() {
                            $(this).html(FGResponse.msg);
                        });

                        $('#div-create-error').addClass('hide').fadeOut('slow', function() {
                            $(this).html('');
                        });

                        // Log the user in.
                        $('#modal-signin #txt-login-email').val(email);
                        $('#modal-signin #txt-login-pass').val(password);

                        $('#modal-signin .btn-user-signin').click();
                    });

                    Ajax.setFailureCallback(function (FGResponse) {
                        ladaBtnSignUp.stop();
                        $('#div-create-error').show().html(FGResponse.msg).addClass('alert alert-warning').removeClass('hide');
                    });

                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            }

            return false;
        },

        /**
         * Manage order as guest
         */
        guestManageOrder: function () {
            //Bind to the guest manage order button
            $('#btn-manage-order').on('click', function (e) {
                e.preventDefault();
                var email = $('#txt-manage-email'),
                    orderId = $('#txt-manage-order-id'),
                    phone = $('#txt-manage-phone'),
                    manageOrderForm = $('#manageorder'),
                    $btnManageOrder = $('#btn-manage-order'),
                    LaddaBtnManageOrder = new FG.Ladda($btnManageOrder.get(0)),
                    Ajax = new FG.AjaxJob('guest/order_lookup'),
                    formValid = true;

                phone.val(phone.val().replace(/[^\+0-9]/g,''));
                FG.Base.initValidateForm(manageOrderForm);
        var requiredValid = FG.Base.validateForm(manageOrderForm);

        if(!requiredValid){
            formValid = false;
        }else{
                    if (!FG.Base.validateEmail(email)) {
                        formValid = false;
                    }
                    if (!FG.Base.validateInteger(orderId)) {
                        formValid = false;
                    }
                    if (!FG.Base.validatePhoneNumber(phone)) {
                        formValid = false;
                    }
        }

                if (formValid) {
                    try {
                        $('#div-manage-error').html('').addClass('hide');

                        //Disable the signin button
                        $btnManageOrder.attr('disabled', 'disabled');

                        LaddaBtnManageOrder.start();

                        Ajax.setLaddaButton(LaddaBtnManageOrder);

                        Ajax.setMessageDiv('#div-manage-error');

                        Ajax.setRequestData({
                            email: email.val(),
                            orderId: orderId.val(),
                            phone: phone.val().replace( "[^\\d]", "" )
                        });

                        Ajax.setSuccessCallback(function (FGResponse) {

                            setTimeout(function () {
                                if (FGResponse.data !== null) {
                                    window.location.href = FGResponse.data.url;
                                } else {
                                    console.log("success and null");
                                }
                            }, 200);
                        });

                        Ajax.setFailureCallback(function (FGResponse) {
                            LaddaBtnManageOrder.stop();
                            $('#div-manage-error').html(FGResponse.msg).removeClass("hide");
                            $btnManageOrder.removeAttr('disabled').text(window.FGTLibs.i18n.t('Look Up'));
                            return false;
                        });

                        Ajax.send();

                    } catch (AjaxException) {
                        Ajax.error(AjaxException.msg);
                    }
                }
        else{
            manageOrderForm.find('input.invalid').first().focus();
        }
            });
        },

        /**
         * Send out a forgot password email message to this user.
         * @param string    url     URL to send this request to
         * @return bool
         */
        sendForgotPasswordEmail: function () {

            var email = $('#txt-forgot-email').val(),
                Ajax = new FG.AjaxJob('user/forgot_password_form'),
                self = this,
                $btnForgotPassword = $('#btn-forgot-password'),
                LaddaBtnForgotPassword = new FG.Ladda($btnForgotPassword.get(0));

            //Clear any existing errors
            $('#div-forgot-error').removeClass('alert-error').removeClass('alert-success');

            FG.Base.initValidateForm($("#forgotpassword"));
            if (!FG.Base.validateForm($("#forgotpassword"))){
                return false;
            }

            $btnForgotPassword.attr('disabled', 'disabled');

            LaddaBtnForgotPassword.start();
            $('#div-forgot-instructions').addClass('hidden');
            $('#div-forgot-response').removeClass('hidden');
            FG.User.enableClickToManageOrder();

            Ajax.setLaddaButton(LaddaBtnForgotPassword);

            try {
                Ajax.setRequestData({
                    email: email
                });

                Ajax.setSuccessCallback(function() {
                    LaddaBtnForgotPassword.stop();
                });

                Ajax.setFailureCallback(function() {
                    LaddaBtnForgotPassword.stop();
                });

                Ajax.setMessageDiv('#div-email-sent-message');
                Ajax.setShowEmailSentMessage(true);

                Ajax.send();
            } catch (AjaxException) {
                LaddaBtnForgotPassword.stop();
                Ajax.error(AjaxException.msg);
            }

            return false;
        },

        /**
         * Update a user's password
         * @param string url handler
         * @return bool
         */
        updatePassword: function () {
            var oldPassword = $("#inputOldPassword").val(),
                newPassword = $("#new_password1").val(),
                confirmPassword = $("#confirm_password").val(),
                Ajax = new FG.Ajax('user/update_password'),
                token = $("#csrf_account").val(),
                lower = new RegExp("[a-z]"),
                upper = new RegExp("[A-Z]"),
                numb = new RegExp("[0-9]"),
                LaddaBtnUpdate = new FG.Ladda($('#btn-submit-password')[0]),
                formValid = true;

                LaddaBtnUpdate.start();
                try {
                    FG.Base.initValidateForm($("#changepassword"));
                    if(!FG.Base.validateForm($("#changepassword"))){
                        formValid = false
                    }

                    if (!lower.test(newPassword) || !upper.test(newPassword) || !numb.test(newPassword) || newPassword.length < 8) {
                        $("#new_password1").addClass("invalid");
                        $("label[for='new_password1']").addClass("invalid");
                        formValid = false;
                    }

                    if (formValid){
                        LaddaBtnUpdate.start();

                        Ajax.setRequestData({
                            oldPassword: oldPassword,
                            newPassword: newPassword,
                            confirmPassword: confirmPassword,
                            csrf_account : token
                        });

                        Ajax.setSuccessCallback(function (FGResponse) {
                            $("#inputOldPassword").val("");
                            $("#new_password1").val("");
                            $("#confirm_password").val("");
                            $("#div-error-password").html(FGResponse.msg).addClass('text-success').show();

                            /*setTimeout(function () {
                                $("#div-error-password").fadeOut('slow', function () {
                                    $(this).removeClass('text-success').removeClass('invalid').html('').hide();
                                });

                            }, 5000);
                            */
                            $('#btn-submit-password').remove();
                            $("#my_account_password :input").prop('readonly', true);
                        });

                        Ajax.setFailureCallback(function (FGResponse) {
                            var message = '';
                            if (FGResponse.msg === "Passwords do not match!"){
                                message = window.FGTLibs.i18n.t('Passwords do not match!');
                                $("#confirm_password").addClass("invalid")
                                $("label[for='confirm_password']").addClass("invalid")
                            } else if (FGResponse.msg === "Old Password is incorrect") {
                                message = window.FGTLibs.i18n.t('Current Password is incorrect');
                                $("#inputOldPassword").addClass("invalid")
                                $("label[for='inputOldPassword']").addClass("invalid")
                            }

                            $("#div-error-password").html(message).addClass('invalid').show();

                            LaddaBtnUpdate.stop();

                            return false;
                        });

                        Ajax.send();
                    }


                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            },

        /**
         * Save user's account information
         * @return void
         */
        saveContactInfo: function () {
            var laddaBtnUpdate = new FG.Ladda($('#btn-submit-account')[0]);

            FG.Base.initValidateForm($('#my_account_contact'));
            if (!FG.Base.validateForm($('#my_account_contact'))) {
                return false;
            }

            const countryCode = FG.Utils.getCountryCode("#phone-intl");
            const phoneNumber = $('#intl-phone-input').val().trim();

            if (!countryCode.length || !phoneNumber.length) {
                $('#phone-intl input[type="tel"]').addClass('invalid');
                $('#missing_phone_error').removeClass('hidden');
                $('#phone_error').addClass('hidden');
                return;
            }

            var validatePhoneOptions = {
                path: 'util/validate',
                parameters: { phone: countryCode + phoneNumber },
                wait: 0,
            };

            resetServerErrors();
            laddaBtnUpdate.start();
            FGTLibs.API.post(validatePhoneOptions)
                .then(function (result) {
                    if (result && !result.valid) {
                        throw Error('server_invalid_phone');
                    }

                    $('#my_phone').val(result.phone_number);

                    submitContactInfo();
                })
                .catch(function (error) {
                    laddaBtnUpdate.stop();

                    if (error.message === 'server_invalid_phone') {
                        $('#phone-intl input[type="tel"]').addClass('invalid');
                        $('#missing_phone_error').addClass('hidden');
                        $('#phone_error').removeClass('hidden');
                        return;
                    }

                    window.location.reload();
                });

            function resetServerErrors() {
                $('#phone_error, #missing_phone_error').addClass('hidden');
            }

            function submitContactInfo() {
                var firstName = $('#my_firstName').val();
                var lastName = $('#my_lastName').val();
                var email = $("#my_email").val();
                var phone = $("#my_phone").val();
                var profileOptOut = $("#my_profile_opt_out").prop('checked');
                var token = $("#csrf_account").val();
                var Ajax = new FG.Ajax('user/contact');

                laddaBtnUpdate.start();

                try {
                    Ajax.setRequestData({
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phone: phone,
                        profileOptOut: profileOptOut,
                        csrf_account: token
                    });

                    Ajax.setSuccessCallback(function (FGResponse) {
                        laddaBtnUpdate.stop();

                        $('#div-error-contact').html(FGResponse.msg).addClass('text-success');

                        $('#btn-submit-account').hide();
                        $("#my_account_contact :input").prop('readonly', true);
                        renderPhoneField(true);

                        setTimeout(function () {
                            $('#div-error-contact').html(FGResponse.msg).empty();
                            $('#btn-submit-account').show();
                            $("#my_account_contact :input").prop('readonly', false);
                            renderPhoneField(false);
                        }, 5000);
                    });

                    Ajax.setFailureCallback(function (FGResponse) {
                        laddaBtnUpdate.stop();

                        $('#div-error-contact').html(FGResponse.msg).addClass('text-danger');
                    });

                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            }
        },

        /**
         * Prime
         */
        bindSignoutLink: function () {

            var self = this;

            $('#sign_out').unbind('click').bind('click', function (e) {

                e.preventDefault();

                $('#modal-signout').modal({
                    show: true,
                    backdrop: true,
                    keyboard: true
                }).animate({
                    top: $(window).height() / 2 - $('#modal-signout').height() / 2
                }, 'fast');

                self.logout();

                return false;
            });
        },

        bindToPaymentPlanMangerPayInFull: function () {

            $('#btn-pay-in-full').unbind('click').bind('click', function () {

                var self = this;
                var origText = $(self).text();

                $(self).attr('disabled', 'disabled').text(window.FGTLibs.i18n.t('Please wait...'));

                if(confirm('Are you sure you want to pay '+$(this).data('balance')+' in full?\n')){


                    var xOrderId = $(this).data('xorderid');

                    var Ajax = new FG.Ajax('user/payment_plan_pay_in_full');

                    Ajax.setMessageDiv('#div-msg-payment-plan');

                    Ajax.setRequestData({ xOrderId: xOrderId });

                    Ajax.setSuccessCallback(function (FGResponse) {
                        if (FGResponse.error == 0) {
                            window.location.reload();
                        }
                    });

                    Ajax.setFailureCallback(function(FGResponse){
                        $(self).removeAttr('disabled').text(origText);
                    });

                    Ajax.send();
                } else {
                    $(self).removeAttr('disabled').text(origText);
                }
            });
        },

        /**
         * Bind to the retry failed payment button for a layaway plan with a failed step
         */
        bindToPaymentPlanManagerRetryPayment : function() {

            $('.cls-btn-retry-step').unbind('click').bind('click', function() {

                var self = this;
                var origText = $(self).text();
                $(self).attr('disabled', 'disabled').text(window.FGTLibs.i18n.t('Please wait...'));

                if(confirm('Are you sure you want to pay '+ $(this).data('payment') +'?\n')){
                    var paymentPlanStepId = $(this).data('paymentplanstepid');
                    var xOrderId = $(this).data('xorderid');

                    var Ajax = new FG.Ajax('user/payment_plan_retry_failed_payment');

                    Ajax.setRequestData(
                        {
                            'paymentPlanStepId' : paymentPlanStepId,
                            'xOrderId' : xOrderId
                        }
                    );

                    Ajax.setMessageDiv('#div-msg-payment-plan');

                    Ajax.setSuccessCallback(function(FGResponse){
                        window.location.reload();
                    });

                    Ajax.setFailureCallback(function(FGResponse){
                        $(self).removeAttr('disabled').text(origText);
                    });

                    Ajax.send();
                } else {
                    $(self).removeAttr('disabled').text(origText);
                }
            });
        },

        /**
         * Ensure that this user does not encounter a cart expired page if they visit the site after a while
         */
        ensureCleanSessionExpiry: function () {

            /**
             * Local DB Object
             * @type {window.FG.DB}
             */
            var db = new FG.DB();

            /**
             * Last UNIX timestamp of any user activity
             * @type {Number}
             */
            var lastActivityTS = db.get('lastActivityTS');

            /**
             * Current UNIX Timestamp
             * @type {Number}
             */
            var currentTS = FG.Base.getCurrentTimestamp();

            //If the difference between the last activity and the current time is greater than the threshold
            if ( (lastActivityTS != null && typeof lastActivityTS != 'undefined') && ((currentTS - lastActivityTS) > this.sessionExpireThresholdSeconds )) {

                //Inactivate the cart
                db.remove('cartActive');
                db.remove('totalCount');
                db.remove('promoCode');
                //Delete the cart timer
                FG.CartTimer.deleteTimer();

                //Delete the cart
                FG.Cart.deleteCart(true);

                // Remove cart tracking data
                FG.tradableBits().removeCartData();

                //Initialize the cart
                FG.Cart.init();

                //Initialize the timer
                FG.CartTimer.init();

                //Reset activity
                db.set('lastActivityTS', currentTS);

            } else {
                //Reset Activity
                db.set('lastActivityTS', FG.Base.getCurrentTimestamp());
            }
        },

        /**
         * Log a user out
         */
        logout: function () {

            var Ajax = new FG.Ajax('user/signout');

            try {

                Ajax.setSuccessCallback(function (FGResponse) {

                    //Nuke all the timeouts in the local database
                    var db = new FG.DB();

                    db.remove('cartExpiry');
                    db.remove('totalCount');
                    db.remove('sessionExpiry');
                    db.set('cartActive', 0);
                    db.nuke();

                    $.removeCookie('FG_LOGGED_IN', { path: '/' });
                    $.removeCookie('FG_AUTH', { path: '/' });
                    $.removeCookie('FG_CUSTOM', { path: '/' });
                    $.removeCookie('FG_LOGIN_TYPE', { path: '/' });

                    var location = FGResponse.data.location;

                    if (typeof location == 'undefined' || location == null || location == 'null' || typeof location == null) {
                        window.location.reload();
                    } else {
                        window.location.href = location;
                    }

                    return false;
                });

                Ajax.setFailureCallback(function () {
                    return false;
                });

                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }

        },

        /**
         * Initialize a user's session
         */
        ensureSessionCookie: function () {
            var sessid = $.cookie('FG_SESSID');
            if (!sessid) {
                var expDate = new Date();
                expDate.setTime(expDate.getTime() + (sessionTimeOut*1000));
                //use jquery.uuid.js to generate uuid
                sessid = $.uuid();
                $.cookie('FG_SESSID', sessid, { path: '/', expires: expDate });
            }
            this.sessionId = sessid;
        },

        /**
         * Initialize the user's logged in status and personId
         */
        ensureLoginStatusProperty: function () {
            this.isLoggedIn = $.cookie('FG_LOGGED_IN') ? true : false;
            this.personId = (PERSON_ID ? PERSON_ID : null);
        },

        /**
         * Initialize the nav bar
         */
        ensureNavigationBar: function () {

            if ($.cookie('FG_LOGGED_IN') == 1) {

                var db = new FG.DB(),
                    picture = db.get('picture'),
                    firstName = db.get('firstName'),
                    fgCustom = $.cookie('FG_CUSTOM') ? JSON.parse($.cookie('FG_CUSTOM')) : null;

                //Check to see if this user selected "continue as guest"
                if (fgCustom != null && (fgCustom.isGuest && fgCustom.isGuest == 1) ||
                    (fgCustom != null && fgCustom.hasOwnProperty('tmpPersonId') && fgCustom.tmpPersonId != null)) {
                    $('#topNav').addClass('guest');
                } else {
                    if (typeof picture != 'undefined' && picture != null) {
                        picture = picture.replace('http:', '').replace('https:', '');
                        $("#span-your-account").addClass('fb').html('<img src="' + picture + '" class="fb-profile-pic" /> ' + firstName + ' <span class="down_caret">&#9660;</span>');
                    }

                    $('#topNav').removeClass('guest');
                }
            } else {
                $('#topNav').addClass('guest');
            }
        },

        getSessionExpireThresholdSeconds: function () {
            return this.sessionExpireThresholdSeconds;
        },

        enableClickToManageOrder: function () {
            $('#manage_order_forgot_password').on('click', function () {
                $('#modal-manage').modal('show');
                $("#modal-signin").modal("hide");
            });
        },
    };
}());
